import React, { Fragment, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantUnits.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelVariantUnits from './ModelVariantUnits';
import { Link } from 'react-router-dom';
import { WidgetVisibility } from '../../utils/widgetManager';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ModelVariantUnitsListTable = ({
  paginatedData = [],
  userProfileWidgets
}) => {

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsInnerTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelVariant.units.unitNumber" defaultMessage="Unit Number" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.deviceSerialNumber" defaultMessage="Device Serial Number" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.installationStreetAddress" defaultMessage="Address" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.installationCity" defaultMessage="City" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.installationSuburbLocation" defaultMessage="Suburb/Location" />
            </th>
            <th>
              <FormattedMessage id="modelVariant.units.installationCountry" defaultMessage="Country" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.UnitId}>
                <tr key={n.UnitId} data-unittest="allocatedUnits">
                  <td>{n.UnitSerialNumber}</td>
                  <td>{n.Name}</td>
                  <td>{n.DeviceSerialNumber}</td>
                  <td>{n.InstallationStreetAddress || '-'}</td>
                  <td>{n.InstallationCity || '-'}</td>
                  <td>{n.InstallationRegion || '-'}</td>
                  <td>{n.InstallationCountry || '-'}</td>
                  <td className={s.btnCol}>
                    <Link to={`/unit/process-flow/${n.UnitSerialNumber}`}>
                      <Button
                        variant="outline-secondary"
                        className={s.viewButton}
                        style={WidgetVisibility(userProfileWidgets, `MODELVARIANT_UNIT_UNITVIEW`)}
                      >
                        <FormattedMessage id="modelVariant.units.view" defaultMessage="VIEW" />
                      </Button>
                    </Link>
                  </td>
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

ModelVariantUnitsListTable.propTypes = {
  allocatedUnits: PropTypes.array
};

export default injectIntl(ModelVariantUnitsListTable);
